module.exports = __webpack_public_path__ + "static/black-19c05d6f3a159f40536831b52bee3e0f.png";